mutation DeleteContract($id: ID!) {
  deleteContract(input: { id: $id }) {
    deletedId
  }
}
